export enum AnimationType {
  LeftToRight = 'LeftToRight',
  RightToLeft = 'RightToLeft',
  CentreOut = 'CentreOut',
  Random = 'Random',
}
